// Global variables for description management (shared across all sections)
var originalEnglishDescription = "";
var originalJapaneseDescription = "";
var descriptionsStored = false;

// EXPAND.JS
console.log("expand loaded");
document.addEventListener("DOMContentLoaded", function () {
  const expandButton = document.getElementById("expand");
  let isExpanded = false;

  const applyExpandedStyles = () => {
    document.querySelector(".product-description-container").style.gap = "15px";
    document.querySelector(
      ".description-dimensions-weight-manufacturing"
    ).style.display = "flex";
    document.querySelector(".product-title-container").style.display = "block";
    document.querySelector(".sku-expand").style["font-size"] = "11.5px";
    document.querySelector(".expand-plus").style.display = "none";
    document.querySelector(".expand-minus").style.display = "block";
  };

  const applyCollapsedStyles = () => {
    document.querySelector(
      ".description-dimensions-weight-manufacturing"
    ).style.display = "none";
    document.querySelector(".product-title-container").style.display = "none";
    document.querySelector(".sku-expand").style["font-size"] = "13px";
    document.querySelector(".expand-plus").style.display = "block";
    document.querySelector(".expand-minus").style.display = "none";
  };

  // Toggle functionality for below 700px
  expandButton.addEventListener("click", function () {
    if (!isExpanded) {
      applyExpandedStyles();
    } else {
      applyCollapsedStyles();
    }
    isExpanded = !isExpanded;

    // Handle dimming when expanding/collapsing description on mobile
    setTimeout(() => {
      if (window.innerWidth <= 430) {
        const descContainer = document.querySelector(
          ".product-description-container"
        );
        const descEnJp = document.querySelector(".product-description-en-jp");
        const instructionImages = document.getElementById("instruction-images");

        if (descContainer && descEnJp && instructionImages) {
          // Check if description height is >= 35dvh and instruction manual is open
          const descHeight = descEnJp.offsetHeight;
          const viewportHeight = window.innerHeight;
          const thirtyFiveDvh = (viewportHeight * 35) / 100;

          if (
            descHeight >= thirtyFiveDvh &&
            instructionImages.style.display === "flex"
          ) {
            // Apply dimming when expanding
            descContainer.classList.add("dimmed");
            document.body.style.overflow = "hidden";
          } else {
            // Remove dimming when collapsing
            descContainer.classList.remove("dimmed");
            document.body.style.overflow = "auto";
          }
        }
      }
    }, 50);
  });

  // Detect window resizing and apply changes
  const mediaQuery = window.matchMedia("(min-width: 701px)");

  const handleResize = (e) => {
    if (e.matches) {
      // Apply expanded styles when browser is above 700px
      applyExpandedStyles();
      isExpanded = true;
    } else {
      // Automatically collapse styles when below 700px
      applyCollapsedStyles();
      isExpanded = false; // Reset expanded state
    }
  };

  mediaQuery.addListener(handleResize); // Listen for screen size changes
  handleResize(mediaQuery); // Initial check when the page loads
});

// SELECT.JS
document.addEventListener("DOMContentLoaded", function () {
  const variantSelect = document.querySelector(".variant-dropdown-button");
  const selectedVariantDisplay = document.querySelector(".selected-variant"); // lol its this
  const priceDisplay = document.querySelector(".price");
  const addToCartForm = document.querySelector("#add-to-cart-form");
  const hiddenVariantIdInput = addToCartForm.querySelector('input[name="id"]');
  const addToCartText = document.querySelector(".add-to-cart-text");
  const soldOutText = document.querySelector(".sold-out-text");
  const addToCartButton = addToCartForm.querySelector("button");
  const productImagesContainer = document.getElementById("product-images");
  const variantImagesContainer = document.getElementById("variant-images");
  const weightDisplay = document.querySelector(".weight");
  const dimensionsDisplay = document.querySelector("#dimensions-display"); // Add dimensions display element
  const instructionImages = document.getElementById("instruction-images"); // Add reference to instruction images

  // Add references for button text elements
  const instructionButton = document.getElementById(
    "instruction-manual-button"
  );
  const jpText = instructionButton.querySelector(".jp-font-close");
  const enText = instructionButton.querySelector(
    ".product-page-button-content p:last-child"
  );

  // Function to update the variant details when the variant changes
  function updateVariantDetails() {
    const selectedOption = variantSelect.options[variantSelect.selectedIndex];
    const selectedVariantId = selectedOption.value;
    const variant = variants[selectedVariantId]; // Get the selected variant data

    // Update the URL with the variant SKU
    if (variant.sku) {
      const newUrl = window.location.pathname + "#" + variant.sku;
      history.replaceState({ sku: variant.sku }, "", newUrl);
    }

    // Update the selected variant display
    selectedVariantDisplay.textContent = variant.title;

    // Update the price display with the correct price
    priceDisplay.textContent = variant.price;

    // Update the hidden input for the selected variant ID in the "Add to Cart" form
    hiddenVariantIdInput.value = selectedVariantId;

    // Check if the variant is sold out - modified logic to handle empty and "false" values
    if (variant.soldOut && variant.soldOut !== "false") {
      // Disable the button and show sold-out text
      addToCartButton.disabled = true;
      addToCartText.style.display = "none"; // Hide "ADD TO CART"
      soldOutText.style.display = "block"; // Show "SOLD OUT"
    } else {
      // Enable the button and show "ADD TO CART"
      addToCartButton.disabled = false;
      addToCartText.style.display = "block"; // Show "ADD TO CART"
      soldOutText.style.display = "none"; // Hide "SOLD OUT"
    }

    // Show or hide the image containers based on the selected variant's images
    if (variant.images && variant.images.length > 0) {
      // Hide all variant image containers first
      const allContainers = variantImagesContainer.querySelectorAll(
        ".img-and-loading-container"
      );
      allContainers.forEach((container) => (container.style.display = "none"));

      // Show only the selected variant's images
      const variantContainers = variantImagesContainer.querySelectorAll(
        `.img-and-loading-container[data-variant-id="${selectedVariantId}"]`
      );

      if (variantContainers.length > 0) {
        productImagesContainer.style.display = "none";
        variantImagesContainer.style.display = "flex";
        variantContainers.forEach(
          (container) => (container.style.display = "block")
        );
      }
    } else {
      productImagesContainer.style.display = "flex";
      variantImagesContainer.style.display = "none";
    }

    // Update the weight display based on the selected variant
    weightDisplay.textContent = variant.weight + " G";

    // Update the dimensions display (this is pre-filtered by Liquid)
    dimensionsDisplay.textContent = variant.dimensions; // Update the dimensions display

    // Hide instruction images if they're currently displayed
    if (instructionImages.style.display === "flex") {
      instructionImages.style.display = "none";

      // Restore original descriptions when switching variants
      if (descriptionsStored) {
        const englishDescElement = document.querySelector(".description-text");
        const japaneseDescElement = document.querySelector(
          ".description-text-jp"
        );

        if (englishDescElement && originalEnglishDescription) {
          englishDescElement.innerHTML = originalEnglishDescription;
        }
        if (japaneseDescElement && originalJapaneseDescription) {
          japaneseDescElement.innerHTML = originalJapaneseDescription;
        }
      }
    }

    // Change button text to "INSTRUCTION MANUAL" (English and Japanese)
    jpText.textContent = "取扱説明";
    enText.textContent = "INSTRUCTION MANUAL";
  }

  // Check URL hash on page load and select variant if SKU is present
  const hash = window.location.hash.substring(1); // Get hash without the '#'
  if (hash) {
    // Find variant with matching SKU
    const variantId = Object.keys(variants).find(
      (id) => variants[id].sku === hash
    );
    if (variantId) {
      variantSelect.value = variantId;
    }
  }

  // Update variant details on page load
  updateVariantDetails();

  // Add event listener for when the variant changes
  variantSelect.addEventListener("change", updateVariantDetails);
});
// I.M.-TYPE2.JS
console.log("i.m loaded");
document.addEventListener("DOMContentLoaded", function () {
  var instructionButton = document.getElementById("instruction-manual-button");
  var productImages = document.getElementById("product-images");
  var variantImages = document.getElementById("variant-images"); // This may not exist
  var instructionImages = document.getElementById("instruction-images");
  var imageContainer = document.querySelector(".product-page-wrapper");
  var mobileImageContainer = document.querySelector(".product-page-scrollable");
  var imgSize = document.querySelectorAll(".img-and-loading-container");
  var jpText = instructionButton.querySelector(".jp-font-close");
  var enText = instructionButton.querySelector(
    ".product-page-button-content p:last-child"
  );

  // Note: originalEnglishDescription, originalJapaneseDescription, and descriptionsStored
  // are now global variables declared at the top of the file

  // Function to handle mobile description dimming
  function handleDescriptionDimming() {
    // Only apply on mobile
    if (window.innerWidth > 430) return;

    const descContainer = document.querySelector(
      ".product-description-container"
    );
    const descEnJp = document.querySelector(".product-description-en-jp");

    if (!descContainer || !descEnJp) return;

    // Check if description height is >= 35dvh
    const descHeight = descEnJp.offsetHeight;
    const viewportHeight = window.innerHeight;
    const thirtyFiveDvh = (viewportHeight * 35) / 100;

    if (
      descHeight >= thirtyFiveDvh &&
      instructionImages.style.display === "flex"
    ) {
      // Dim the description background and prevent body scroll
      descContainer.classList.add("dimmed");
      document.body.style.overflow = "hidden";
    } else {
      // Remove dimming and allow body scroll
      descContainer.classList.remove("dimmed");
      document.body.style.overflow = "auto";
    }
  }

  function handleResize() {
    imgSize.forEach((element) => {
      if (instructionImages.style.display === "flex") {
        if (window.innerWidth <= 700) {
          element.style.width = "75%";
        } else {
          element.style.width = "50%";
        }
      } else if (productImages.style.display === "flex") {
        if (window.innerWidth <= 700) {
          element.style.width = "80%";
        } else {
          element.style.width = "75%";
        }
      }
    });

    // Recalculate dimming on resize
    handleDescriptionDimming();
  }

  window.addEventListener("resize", handleResize);

  // Variable to track the currently visible images
  var currentlyVisibleImages = "";

  instructionButton.addEventListener("click", function () {
    // Step 1: Check which images are currently displayed
    var isProductImagesVisible =
      productImages && productImages.style.display === "flex";
    var isVariantImagesVisible =
      variantImages && variantImages.style.display === "flex";

    // Determine which images are currently visible
    if (isProductImagesVisible) {
      currentlyVisibleImages = "product";
    } else if (isVariantImagesVisible) {
      currentlyVisibleImages = "variant";
    }

    // Step 2: Hide currently visible images and show instruction images
    if (instructionImages.style.display === "flex") {
      // Step 3: Show the previously visible images when clicking again
      // Pause any playing videos before switching
      const playingVideos = instructionImages.querySelectorAll("video");
      playingVideos.forEach((video) => {
        video.pause();
      });

      // Restore original descriptions
      if (descriptionsStored) {
        const englishDescElement = document.querySelector(".description-text");
        const japaneseDescElement = document.querySelector(
          ".description-text-jp"
        );

        if (englishDescElement) {
          englishDescElement.innerHTML = originalEnglishDescription;
        }
        if (japaneseDescElement) {
          japaneseDescElement.innerHTML = originalJapaneseDescription;
        }
      }

      instructionImages.style.display = "none";

      if (currentlyVisibleImages === "product") {
        productImages.style.display = "flex"; // Show product images
      } else if (currentlyVisibleImages === "variant" && variantImages) {
        variantImages.style.display = "flex"; // Show variant images if it exists
      }

      imgSize.forEach((element) => {
        if (window.innerWidth <= 700) {
          element.style.width = "80%";
        } else {
          element.style.width = "75%";
        }
        element.style.pointerEvents = "all";
      });

      instructionImages.style.display = "none"; // Hide instruction images

      imageContainer.scrollTop = 0;
      mobileImageContainer.scrollTop = 0; // Reset scroll for mobile
      if (window.innerWidth <= 700) {
        window.scrollTo(0, 0); // Reset scroll for the entire page on mobile
      }

      // Change button text back to "INSTRUCTION MANUAL" (English and Japanese)
      jpText.textContent = "取扱説明";
      enText.textContent = "INSTRUCTION MANUAL";

      // Remove dimming when closing instruction manual
      handleDescriptionDimming();
    } else {
      // Hide currently visible images (product or variant)
      if (currentlyVisibleImages === "product") {
        productImages.style.display = "none";
      } else if (currentlyVisibleImages === "variant" && variantImages) {
        variantImages.style.display = "none"; // Hide variant images if it exists
      }

      // Show instruction images
      imgSize.forEach((element) => {
        element.style.width = "50%";
        element.style.pointerEvents = "none";
      });

      // Store original descriptions and replace with extended descriptions
      if (!descriptionsStored) {
        const englishDescElement = document.querySelector(".description-text");
        const japaneseDescElement = document.querySelector(
          ".description-text-jp"
        );

        if (englishDescElement) {
          originalEnglishDescription = englishDescElement.innerHTML;
        }
        if (japaneseDescElement) {
          originalJapaneseDescription = japaneseDescElement.innerHTML;
        }
        descriptionsStored = true;
      }

      // Replace with extended descriptions from hidden containers
      const englishDescElement = document.querySelector(".description-text");
      const japaneseDescElement = document.querySelector(
        ".description-text-jp"
      );

      // Get extended descriptions from hidden containers
      const extendedEnglishContainer = document.getElementById(
        "extended-english-desc"
      );
      const extendedJapaneseContainer = document.getElementById(
        "extended-japanese-desc"
      );

      // Get the innerHTML from the hidden containers
      // metafield_tag wraps content in a div, so we get the innerHTML directly
      const extendedEnglish = extendedEnglishContainer
        ? extendedEnglishContainer.innerHTML
        : "";
      const extendedJapanese = extendedJapaneseContainer
        ? extendedJapaneseContainer.innerHTML
        : "";

      // Only replace if we have actual extended content
      // Important: Keep the same structure - English first, then Japanese
      if (englishDescElement && extendedEnglish.trim() !== "") {
        // Keep the HTML formatting (including line breaks, paragraphs, empty lines, etc.)
        // Do NOT trim - this preserves whitespace and empty paragraphs
        englishDescElement.innerHTML = extendedEnglish;
      }
      if (japaneseDescElement && extendedJapanese.trim() !== "") {
        // Keep the HTML formatting (including line breaks, paragraphs, empty lines, etc.)
        // Do NOT trim - this preserves whitespace and empty paragraphs
        japaneseDescElement.innerHTML = extendedJapanese;
      }

      instructionImages.style.display = "flex";
      window.addEventListener("resize", handleResize);
      handleResize();

      // Apply dimming if needed on mobile
      handleDescriptionDimming();

      // Reset scroll position for desktop and mobile containers
      imageContainer.scrollTop = 0;
      mobileImageContainer.scrollTop = 0; // Reset scroll for mobile
      if (window.innerWidth <= 700) {
        window.scrollTo(0, 0); // Reset scroll for the entire page on mobile
      }

      // Change button text to "PRODUCT IMAGES" (English and Japanese)
      jpText.textContent = "商品画像";
      enText.textContent = "IMAGES";
    }
  });
});
